<template>
  <div class="base-actions-block">
    <button v-if="isEdit" class="button" type="button" @click="$emit('edit')">
      <BaseIconSvoi class="icon" icon="content-edit/edit-2" size="m" />
    </button>
    <button v-if="isImport" class="button" type="button" @click="$emit('import')">
      <BaseIconSvoi class="icon" icon="arrow/import" size="m" />
    </button>
    <button v-if="isCopy" class="button" type="button" @click="onClickCopyLink">
      <BaseIconSvoi class="icon" icon="arrow/right-up" size="m" />
    </button>
    <button v-if="isDelete" class="button" type="button" @click="$emit('delete')">
      <BaseIconSvoi class="icon" icon="essential/trash" size="m" />
    </button>
  </div>
</template>

<script lang="ts" setup>
  import { BaseIconSvoi } from '~/components/base-ui/icon'
  import { useNotificationsStore } from '~/store/notifications'
  import { getHosts } from '~/shared/utils/env'

  interface Props {
    isEdit?: boolean
    isImport?: boolean
    isCopy?: boolean
    isDelete?: boolean
  }

  withDefaults(defineProps<Props>(), {
    isEdit: false,
    isImport: false,
    isCopy: false,
    isDelete: false,
  })

  defineEmits<{
    (e: 'delete' | 'import' | 'edit'): void
  }>()

  const route = useRoute()
  const notifications = useNotificationsStore()
  const config = useRuntimeConfig()
  const hosts = getHosts({
    NUXT_PUBLIC_ENVIRONMENT_STAND: config.public.environmentStand,
  })
  const externalHost = hosts.externalHost
  const fullUrl = new URL(route.fullPath, externalHost).href

  const onClickCopyLink = () => {
    if (navigator && navigator.clipboard) {
      navigator.clipboard.writeText(fullUrl).then(
        () => notifications.pushSuccess('Данные успешно скопированы в буфер обмена.'),
        () => notifications.pushError('Произошла ошибка при копировании в буфер обмена.')
      )
    } else {
      notifications.pushError('Ваш браузер не поддерживает работу с буфером обмена.')
    }
  }
</script>

<style lang="scss" scoped>
  .base-actions-block {
    display: flex;
    align-items: center;
    gap: 8px;

    @include vp-1439 {
      gap: 4px;
    }

    > .button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      min-width: 40px;
      height: 40px;
      border-radius: 50%;
      border: 1px solid #dedfdf;
      background-color: $color-default-white;

      @include hover {
        cursor: pointer;

        > .icon {
          color: $color-kiwi-50;
        }
      }

      @include vp-1439 {
        width: 32px;
        min-width: 32px;
        height: 32px;
      }

      > .icon {
        transition: color 0.3s ease-in-out;

        @include vp-1439 {
          width: 19px;
          min-width: 19px;
          height: 19px;
          min-height: 19px;
        }
      }
    }
  }
</style>
